
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hmdCl", function(module, exports) {

var $frIzR = parcelRequire("frIzR");

/**
 * @generated SignedSource<<6f3ef8b0ff3a8be606ccf2816509ce7f>>
 * @relayHash dd0f052052ed3597a2097b1368400d41
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2b1d2562dba9544d356ce5e61fb4f32edcbf19924917ad4aa8b46c551f1cc1d2
const $7b3f0468c74b768c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v2 = {
        "args": [
            v1 /*: any*/ 
        ],
        "concreteType": "ContentContributors",
        "kind": "LinkedField",
        "name": "contentContributors",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isCurrentUserContributor"
            }
        ]
    }, v3 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "current",
                "draft"
            ]
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageHeaderLoomButtonQuery",
            "selections": [
                v2 /*: any*/ ,
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageHeaderLoomButtonQuery",
            "selections": [
                v2 /*: any*/ ,
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "dd0f052052ed3597a2097b1368400d41",
            "id": "2b1d2562dba9544d356ce5e61fb4f32edcbf19924917ad4aa8b46c551f1cc1d2",
            "metadata": {},
            "name": "PageHeaderLoomButtonQuery",
            "operationKind": "query",
            "text": "query PageHeaderLoomButtonQuery($contentId:ID!){contentContributors(id:$contentId){isCurrentUserContributor},content(id:$contentId,status:[\"current\",\"draft\"]){nodes{id,operations{operation,targetType},history{ownedBy{__typename,...on KnownUser{accountId}}}}}}"
        }
    };
}();
$7b3f0468c74b768c$var$node.hash = "14816623bd7509f545a7f75bf7e00ab0";
var $7b3f0468c74b768c$export$2e2bcd8739ae039 = $7b3f0468c74b768c$var$node;



var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $jMyy4 = parcelRequire("jMyy4");


var $1qfLF = parcelRequire("1qfLF");


var $inPa6 = parcelRequire("inPa6");


var $3gadb = parcelRequire("3gadb");


var $7aRa9 = parcelRequire("7aRa9");


var $9uAPw = parcelRequire("9uAPw");


var $39rFu = parcelRequire("39rFu");


var $iXzFq = parcelRequire("iXzFq");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $bQm3c = parcelRequire("bQm3c");


var $aSsfA = parcelRequire("aSsfA");


var $ikPi2 = parcelRequire("ikPi2");


var $6mKj3 = parcelRequire("6mKj3");


var $1mIgH = parcelRequire("1mIgH");


var $531iT = parcelRequire("531iT");


var $4GcXp = parcelRequire("4GcXp");


var $9wGTI = parcelRequire("9wGTI");

var $5f1bcad77068d6e7$export$8bfaa5cd7df1dbf0 = /*#__PURE__*/ function(PostLoomRecordingCTA) {
    PostLoomRecordingCTA["EDITOR_INSERT"] = "editorInsert";
    PostLoomRecordingCTA["PAGE_COMMENT_INSERT"] = "pageCommentInsert";
    PostLoomRecordingCTA["COPY_LINK"] = "copyLink";
    PostLoomRecordingCTA["OPEN_ON_LOOM"] = "openOnLoom";
    return PostLoomRecordingCTA;
}({})// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
;
const $5f1bcad77068d6e7$var$ButtonSpacer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1ul91ul9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $5f1bcad77068d6e7$var$PageHeaderLoomButtonComponent = (t0)=>{
    const $ = (0, $frIzR.c)(60);
    const { contentId: contentId, dataVC: dataVC, label: label, spaceKey: spaceKey, contentType: contentType, flags: flags, ssrPlaceholderIdProp: ssrPlaceholderIdProp, isCircle: t1, testId: testId, source: t2, isDisabled: t3 } = t0;
    const isCircle = t1 === undefined ? false : t1;
    const source = t2 === undefined ? "pageHeader" : t2;
    const isDisabled = t3 === undefined ? false : t3;
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { loadEditor: loadEditor } = (0, $39rFu.useEditPageLoadingActions)();
    const [, loomInsertUrlActions] = (0, $ikPi2.useLoomInsertUrlState)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { isLoomAutoProvisionEnabled: isLoomAutoProvisionEnabled, setSeenSpotlight: setSeenSpotlight } = (0, $1mIgH.useIsLoomAutoProvisionEnabled)();
    let t4;
    if ($[0] !== contentId || $[1] !== contentType || $[2] !== loadEditor || $[3] !== loomInsertUrlActions || $[4] !== spaceKey) {
        t4 = (video)=>{
            loomInsertUrlActions.updateFullPageEditorLoomUrl(video);
            const redirectUrl = (0, $iXzFq.getUrlForContentType)({
                contentType: contentType,
                spaceKey: spaceKey,
                contentId: contentId,
                redirectToEditor: true
            });
            loadEditor({
                contentId: contentId,
                spaceKey: spaceKey,
                redirectUrl: redirectUrl,
                contentType: contentType
            });
        };
        $[0] = contentId;
        $[1] = contentType;
        $[2] = loadEditor;
        $[3] = loomInsertUrlActions;
        $[4] = spaceKey;
        $[5] = t4;
    } else t4 = $[5];
    const saveLoomUrlAndLoadEditor = t4;
    let t5;
    if ($[6] !== experienceTracker) {
        t5 = (postLoomRecordingCTA)=>{
            experienceTracker.start({
                name: (0, $irVI7.LOOM_PAGE_HEADER_CONTENT_INSERTION),
                timeout: (0, $aJPUt.ExperienceTimeout).LOOM_PAGE_HEADER_CONTENT_INSERTION,
                attributes: {
                    postLoomRecordingCTA: postLoomRecordingCTA
                }
            });
        };
        $[6] = experienceTracker;
        $[7] = t5;
    } else t5 = $[7];
    const beginExperienceTracker = t5;
    let t6;
    if ($[8] !== contentId) {
        t6 = {
            variables: {
                contentId: contentId
            }
        };
        $[8] = contentId;
        $[9] = t6;
    } else t6 = $[9];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $7b3f0468c74b768c$export$2e2bcd8739ae039), t6);
    let openLoomRecorderParams;
    let postLoomRecordingCTA_0;
    let resetInsertFunctionOnUnmount;
    if ($[10] !== beginExperienceTracker || $[11] !== contentType || $[12] !== data?.content?.nodes?.[0] || $[13] !== data?.contentContributors?.isCurrentUserContributor || $[14] !== loomInsertUrlActions || $[15] !== saveLoomUrlAndLoadEditor || $[16] !== userId) {
        postLoomRecordingCTA_0 = "openOnLoom";
        resetInsertFunctionOnUnmount = false;
        const contentData = data?.content?.nodes?.[0];
        const isContentContributor = data?.contentContributors?.isCurrentUserContributor || contentData?.history?.ownedBy?.accountId === userId;
        const canEdit = contentData?.operations?.some((operation)=>operation?.operation === "update" && operation?.targetType === contentType);
        const canComment = contentData?.operations?.some($5f1bcad77068d6e7$var$_temp);
        if (canEdit && isContentContributor && contentType !== "database" && contentType !== "slide") {
            postLoomRecordingCTA_0 = "editorInsert";
            openLoomRecorderParams = {
                onInsert: (_, video_0)=>{
                    beginExperienceTracker(postLoomRecordingCTA_0);
                    saveLoomUrlAndLoadEditor(video_0);
                },
                insertButtonText: "Insert Loom video"
            };
        } else if (canComment && contentType !== "database" && contentType !== "slide") {
            postLoomRecordingCTA_0 = "pageCommentInsert";
            resetInsertFunctionOnUnmount = true;
            openLoomRecorderParams = {
                onInsert: (__0, video_1)=>{
                    beginExperienceTracker(postLoomRecordingCTA_0);
                    loomInsertUrlActions.updatePageCommentEditorLoomUrl(video_1);
                    const openPageCommentEditorButton = document.getElementById("addCommentButton");
                    openPageCommentEditorButton && openPageCommentEditorButton.click();
                },
                insertButtonText: "Add to comment"
            };
        } else postLoomRecordingCTA_0 = "copyLink";
        $[10] = beginExperienceTracker;
        $[11] = contentType;
        $[12] = data?.content?.nodes?.[0];
        $[13] = data?.contentContributors?.isCurrentUserContributor;
        $[14] = loomInsertUrlActions;
        $[15] = saveLoomUrlAndLoadEditor;
        $[16] = userId;
        $[17] = openLoomRecorderParams;
        $[18] = postLoomRecordingCTA_0;
        $[19] = resetInsertFunctionOnUnmount;
    } else {
        openLoomRecorderParams = $[17];
        postLoomRecordingCTA_0 = $[18];
        resetInsertFunctionOnUnmount = $[19];
    }
    let t7;
    if ($[20] !== flags || $[21] !== resetInsertFunctionOnUnmount) {
        t7 = {
            entryPointLocation: "pageHeader",
            flags: flags,
            resetInsertFunctionOnUnmount: resetInsertFunctionOnUnmount
        };
        $[20] = flags;
        $[21] = resetInsertFunctionOnUnmount;
        $[22] = t7;
    } else t7 = $[22];
    const { openLoomRecorder: openLoomRecorder, isOpeningRecorder: isOpeningRecorder } = (0, $9uAPw.useLoomRecorderEntryPoint)(t7);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t8;
    if ($[23] !== contentType || $[24] !== createAnalyticsEvent || $[25] !== isLoomAutoProvisionEnabled || $[26] !== openLoomRecorder || $[27] !== openLoomRecorderParams || $[28] !== pageMode || $[29] !== postLoomRecordingCTA_0 || $[30] !== setSeenSpotlight || $[31] !== source) {
        t8 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "createLoomHeaderItem",
                    source: source,
                    attributes: {
                        postLoomRecordingCTA: postLoomRecordingCTA_0,
                        contentType: contentType,
                        pageMode: pageMode
                    }
                }
            }).fire();
            openLoomRecorder(openLoomRecorderParams);
            if (isLoomAutoProvisionEnabled && (0, $9wGTI.fg)("loom_post_ap_add_spotlight_to_confluence_couse")) setSeenSpotlight();
        };
        $[23] = contentType;
        $[24] = createAnalyticsEvent;
        $[25] = isLoomAutoProvisionEnabled;
        $[26] = openLoomRecorder;
        $[27] = openLoomRecorderParams;
        $[28] = pageMode;
        $[29] = postLoomRecordingCTA_0;
        $[30] = setSeenSpotlight;
        $[31] = source;
        $[32] = t8;
    } else t8 = $[32];
    openLoomRecorderParams;
    postLoomRecordingCTA_0;
    const handleClick = t8;
    if (isLoomAutoProvisionEnabled && (0, $9wGTI.fg)("loom_post_ap_add_spotlight_to_confluence_couse")) {
        let t9;
        if ($[33] !== dataVC || $[34] !== handleClick || $[35] !== isCircle || $[36] !== isDisabled || $[37] !== isOpeningRecorder || $[38] !== label || $[39] !== ssrPlaceholderIdProp || $[40] !== testId) {
            t9 = isCircle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                label: label,
                isLoading: isOpeningRecorder,
                onClick: handleClick,
                appearance: "subtle",
                shape: "circle",
                icon: (0, $531iT.LoomVideoIcon),
                testId: testId,
                isDisabled: isDisabled && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                appearance: "subtle",
                icon: (0, $531iT.LoomVideoIcon),
                label: label,
                onClick: handleClick,
                isLoading: isOpeningRecorder,
                "data-vc": dataVC,
                ...ssrPlaceholderIdProp,
                testId: testId,
                isDisabled: isDisabled && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false)
            });
            $[33] = dataVC;
            $[34] = handleClick;
            $[35] = isCircle;
            $[36] = isDisabled;
            $[37] = isOpeningRecorder;
            $[38] = label;
            $[39] = ssrPlaceholderIdProp;
            $[40] = testId;
            $[41] = t9;
        } else t9 = $[41];
        const baseLoomIconButton = t9;
        let t10;
        if ($[42] !== baseLoomIconButton) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5f1bcad77068d6e7$var$ButtonSpacer, null, baseLoomIconButton);
            $[42] = baseLoomIconButton;
            $[43] = t10;
        } else t10 = $[43];
        let t11;
        if ($[44] !== handleClick || $[45] !== setSeenSpotlight || $[46] !== t10) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4GcXp.LoomSpotlightWrapper), {
                onSpotlightPrimaryActionClick: handleClick,
                onSpotlightClose: setSeenSpotlight,
                touchpoint: "page-header"
            }, t10);
            $[44] = handleClick;
            $[45] = setSeenSpotlight;
            $[46] = t10;
            $[47] = t11;
        } else t11 = $[47];
        return t11;
    }
    let t9;
    if ($[48] !== dataVC || $[49] !== handleClick || $[50] !== isCircle || $[51] !== isDisabled || $[52] !== isOpeningRecorder || $[53] !== label || $[54] !== ssrPlaceholderIdProp || $[55] !== testId) {
        t9 = (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5f1bcad77068d6e7$var$ButtonSpacer, null, isCircle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                label: label,
                ...tooltipProps,
                isLoading: isOpeningRecorder,
                onClick: handleClick,
                appearance: "subtle",
                shape: "circle",
                icon: (0, $531iT.LoomVideoIcon),
                testId: testId,
                isDisabled: isDisabled && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                appearance: "subtle",
                icon: (0, $531iT.LoomVideoIcon),
                label: label,
                ...tooltipProps,
                onClick: handleClick,
                isLoading: isOpeningRecorder,
                "data-vc": dataVC,
                ...ssrPlaceholderIdProp,
                testId: testId,
                isDisabled: isDisabled && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false)
            }));
        $[48] = dataVC;
        $[49] = handleClick;
        $[50] = isCircle;
        $[51] = isDisabled;
        $[52] = isOpeningRecorder;
        $[53] = label;
        $[54] = ssrPlaceholderIdProp;
        $[55] = testId;
        $[56] = t9;
    } else t9 = $[56];
    let t10;
    if ($[57] !== label || $[58] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: label,
            position: "left"
        }, t9);
        $[57] = label;
        $[58] = t9;
        $[59] = t10;
    } else t10 = $[59];
    const baseLoomButton = t10;
    return baseLoomButton;
};
const $5f1bcad77068d6e7$export$eabaf9dbc33f86dd = (0, $7aRa9.withFlags)($5f1bcad77068d6e7$var$PageHeaderLoomButtonComponent);
function $5f1bcad77068d6e7$var$_temp(operation_0) {
    return operation_0?.targetType === "comment" && operation_0?.operation === "create";
}
module.exports["PostLoomRecordingCTA"] = $5f1bcad77068d6e7$export$8bfaa5cd7df1dbf0;
module.exports["PageHeaderLoomButton"] = $5f1bcad77068d6e7$export$eabaf9dbc33f86dd;

});

parcelRegister("iXzFq", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $71e3d8e13a87be5f$var$getLegacyActionUrl = (redirectToEditor, contentId)=>{
    if (redirectToEditor) return `${0, $jlIaF.CONTEXT_PATH}/pages/resumedraft.action?draftId=${contentId}`;
    return `${0, $jlIaF.CONTEXT_PATH}/pages/viewpage.action?pageId=${contentId}`;
};
const $71e3d8e13a87be5f$export$11b68a3633074ac0 = ({ contentType: contentType, contentSubType: contentSubType = null, contentId: contentId, spaceKey: spaceKey, redirectToEditor: redirectToEditor = false, useLegacyActionUrl: useLegacyActionUrl = false })=>{
    // assume all page sub types will only redirect to view page
    // can refactor to be more specific if needed
    if (contentType === 'page' && contentSubType !== null) return (0, $1NBp8.VIEW_PAGE).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    if (contentType === 'page' && useLegacyActionUrl) return $71e3d8e13a87be5f$var$getLegacyActionUrl(redirectToEditor, contentId);
    if (contentType === 'page' && redirectToEditor) return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        spaceKey: spaceKey,
        contentType: 'pages',
        contentId: contentId
    });
    if (contentType === 'blogpost' && redirectToEditor) return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: 'blog'
    });
    switch(contentType){
        case 'page':
            return (0, $1NBp8.VIEW_PAGE).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'blogpost':
            return (0, $1NBp8.VIEW_BLOG).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'whiteboard':
            return (0, $1NBp8.WHITEBOARD_BOARD).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'database':
            return (0, $1NBp8.DATABASE_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'slide':
            return (0, $1NBp8.SLIDES_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'embed':
            return (0, $1NBp8.EMBED_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'folder':
            return (0, $1NBp8.FOLDER_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
    }
    return null;
};
module.exports["getUrlForContentType"] = $71e3d8e13a87be5f$export$11b68a3633074ac0;

});

parcelRegister("ikPi2", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $2748374594b3931f$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        fullPageEditorLoomUrl: undefined,
        pageCommentEditorLoomUrl: undefined,
        inlineCommentEditorLoomUrl: undefined
    },
    actions: {
        updateFullPageEditorLoomUrl: (video)=>({ setState: setState })=>{
                setState({
                    fullPageEditorLoomUrl: video
                });
            },
        updatePageCommentEditorLoomUrl: (video)=>({ setState: setState })=>{
                setState({
                    pageCommentEditorLoomUrl: video
                });
            }
    },
    name: 'loomUrlToInsert'
});
const $2748374594b3931f$export$f76207310d699374 = (0, $9zUhf.createHook)($2748374594b3931f$var$Store);
const $2748374594b3931f$export$b51bf851d750866c = ()=>$2748374594b3931f$export$f76207310d699374()[1];
module.exports["useLoomInsertUrlState"] = $2748374594b3931f$export$f76207310d699374;

});

parcelRegister("1mIgH", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $kOUwv = parcelRequire("kOUwv");

const $52c981664dd3b13c$var$LOOM_AUTO_PROVISION_TRAIT_NAME = 'loom.auto-provision.activationDate';
const $52c981664dd3b13c$export$c0bbaab34e52ce2 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(10);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            skipBootstrap: !(0, $9wGTI.fg)("loom_post_ap_add_spotlight_to_confluence_couse")
        };
        $[0] = t0;
    } else t0 = $[0];
    const { data: siteTraits } = (0, $kOUwv.useSiteTraits)(t0);
    let t1;
    if ($[1] !== siteTraits?.attributes) {
        t1 = (0, $9wGTI.fg)("loom_post_ap_add_spotlight_to_confluence_couse") && (siteTraits?.attributes?.some($52c981664dd3b13c$var$_temp) ?? false);
        $[1] = siteTraits?.attributes;
        $[2] = t1;
    } else t1 = $[2];
    const hasGrantedApLoomAccessDateTrait = t1;
    let t2;
    if ($[3] !== hasGrantedApLoomAccessDateTrait) {
        t2 = hasGrantedApLoomAccessDateTrait && (0, $9wGTI.fg)("loom_post_ap_add_spotlight_to_confluence_couse") ? !!(0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LOOM_AUTO_PROVISION_SPOTLIGHT_SEEN) : false;
        $[3] = hasGrantedApLoomAccessDateTrait;
        $[4] = t2;
    } else t2 = $[4];
    const hasSeenSpotlight = t2;
    let t3;
    if ($[5] !== hasGrantedApLoomAccessDateTrait || $[6] !== hasSeenSpotlight) {
        t3 = hasGrantedApLoomAccessDateTrait && !hasSeenSpotlight && (0, $9wGTI.fg)("loom_post_ap_add_spotlight_to_confluence_couse");
        $[5] = hasGrantedApLoomAccessDateTrait;
        $[6] = hasSeenSpotlight;
        $[7] = t3;
    } else t3 = $[7];
    const isLoomAutoProvisionEnabled = t3;
    const setSeenSpotlight = $52c981664dd3b13c$var$_temp2;
    let t4;
    if ($[8] !== isLoomAutoProvisionEnabled) {
        t4 = {
            isLoomAutoProvisionEnabled: isLoomAutoProvisionEnabled,
            setSeenSpotlight: setSeenSpotlight
        };
        $[8] = isLoomAutoProvisionEnabled;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ()=>{
    // 1. check trait 'loom.auto-provision.activationDate' is set against the SITE
    // Skip this expensive site traits lookup if feature is disabled
    const { data: siteTraits } = (0, $kOUwv.useSiteTraits)({
        skipBootstrap: !(0, $9wGTI.fg)('loom_post_ap_add_spotlight_to_confluence_couse')
    });
    const hasGrantedApLoomAccessDateTrait = (0, $9wGTI.fg)('loom_post_ap_add_spotlight_to_confluence_couse') && (siteTraits?.attributes?.some((attr)=>attr.name === $52c981664dd3b13c$var$LOOM_AUTO_PROVISION_TRAIT_NAME) ?? false);
    // 2. check if there is 'seen' value set in the local storage
    // Skip this localStorage lookup if feature is disabled or trait is missing
    const hasSeenSpotlight = hasGrantedApLoomAccessDateTrait && (0, $9wGTI.fg)('loom_post_ap_add_spotlight_to_confluence_couse') ? !!(0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LOOM_AUTO_PROVISION_SPOTLIGHT_SEEN) : false;
    const isLoomAutoProvisionEnabled = hasGrantedApLoomAccessDateTrait && !hasSeenSpotlight && (0, $9wGTI.fg)('loom_post_ap_add_spotlight_to_confluence_couse');
    const setSeenSpotlight = (0, $42omo.useCallback)(()=>{
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).LOOM_AUTO_PROVISION_SPOTLIGHT_SEEN, 'true');
    }, []);
    return {
        isLoomAutoProvisionEnabled: isLoomAutoProvisionEnabled,
        setSeenSpotlight: setSeenSpotlight
    };
};
function $52c981664dd3b13c$var$_temp(attr) {
    return attr.name === $52c981664dd3b13c$var$LOOM_AUTO_PROVISION_TRAIT_NAME;
}
function $52c981664dd3b13c$var$_temp2() {
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).LOOM_AUTO_PROVISION_SPOTLIGHT_SEEN, "true");
}
module.exports["useIsLoomAutoProvisionEnabled"] = $52c981664dd3b13c$export$c0bbaab34e52ce2;

});

parcelRegister("kOUwv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $d684465712516a35$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $d684465712516a35$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $d684465712516a35$export$2d97e7bb018b0cfb = (0, $1P1Tu.createStore)({
    initialState: $d684465712516a35$var$initialState,
    actions: $d684465712516a35$var$actions,
    name: 'siteTraitsStore'
});
const $d684465712516a35$export$c84f691b170cbee3 = (0, $9zUhf.createHook)($d684465712516a35$export$2d97e7bb018b0cfb);
const $d684465712516a35$export$2aca02eeb1d46515 = (0, $9zUhf.createActionsHook)($d684465712516a35$export$2d97e7bb018b0cfb);
async function $d684465712516a35$var$fetchSiteTraitsData(cloudId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $d684465712516a35$var$hasFetched = false;
function $d684465712516a35$export$f1fbc6ad89f91b89() {
    $d684465712516a35$var$hasFetched = false;
}
function $d684465712516a35$var$getSiteTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.site);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.site);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $d684465712516a35$export$fcebe75065597a98({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $42omo.useMemo)(()=>$d684465712516a35$var$getSiteTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $d684465712516a35$export$c84f691b170cbee3();
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $42omo.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($d684465712516a35$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId) return;
        $d684465712516a35$var$hasFetched = true;
        storeActions.start();
        $d684465712516a35$var$fetchSiteTraitsData(cloudId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteTraits"] = $d684465712516a35$export$fcebe75065597a98;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("4GcXp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $bqAtB = parcelRequire("bqAtB");

var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $fdtRy = parcelRequire("fdtRy");

var $fNcP1 = parcelRequire("fNcP1");


var $cOrQJ = parcelRequire("cOrQJ");


var $6f0Oj = parcelRequire("6f0Oj");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $5M6IM = parcelRequire("5M6IM");


var $kqrkb = parcelRequire("kqrkb");


var $cO1el = parcelRequire("cO1el");


var $gj7hi = parcelRequire("gj7hi");

const $cec48c407c49ce5f$var$i18n = (0, $cgtv4.defineMessages)({
    titleForPageHeader: {
        id: "loom-utils.loom-spotlight-wrapper.title-for-page-header",
        defaultMessage: "Share your work with video"
    },
    descriptionForPageHeader: {
        id: "loom-utils.loom-spotlight-wrapper.description-for-page-header",
        defaultMessage: "Save time and engage your team with a video walkthrough, demo, update, and more."
    },
    titleForInlineComment: {
        id: "loom-utils.loom-spotlight-wrapper.title-for-inline-comment",
        defaultMessage: "Add more context with video"
    },
    descriptionForInlineComment: {
        id: "loom-utils.loom-spotlight-wrapper.description-for-inline-comment",
        defaultMessage: "Give your team more context so they can quickly understand and respond."
    },
    primaryAction: {
        id: "loom-utils.loom-spotlight-wrapper.primary-action",
        defaultMessage: "Try now"
    }
});
const $cec48c407c49ce5f$var$TOGGLE_DELAY_TIME_MS = 400;
const $cec48c407c49ce5f$var$spotlightContentContainerStyles = (0, $ecnYn.xcss)({
    position: 'fixed'
});
const $cec48c407c49ce5f$export$fe7da627f6fba85a = ({ children: children, touchpoint: touchpoint, onSpotlightPrimaryActionClick: onSpotlightPrimaryActionClick, onSpotlightClose: onSpotlightClose })=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const isDarkMode = colorMode === 'dark';
    const intl = (0, $8C5kA.default)();
    // Spotlight state management for Loom auto-provisioning spotlight
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const closePopupTimerRef = (0, $42omo.useRef)(null);
    const openPopupTimerRef = (0, $42omo.useRef)(null);
    const triggerElementRef = (0, $42omo.useRef)(null);
    const clearClosePopupTimer = (0, $42omo.useCallback)(()=>{
        if (closePopupTimerRef.current) {
            clearTimeout(closePopupTimerRef.current);
            closePopupTimerRef.current = null;
        }
    }, []);
    const clearOpenPopupTimer = (0, $42omo.useCallback)(()=>{
        if (openPopupTimerRef.current) {
            clearTimeout(openPopupTimerRef.current);
            openPopupTimerRef.current = null;
        }
    }, []);
    const safeClosePopup = (0, $42omo.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const startClosePopupTimer = (0, $42omo.useCallback)(()=>{
        clearOpenPopupTimer();
        if (!closePopupTimerRef.current) closePopupTimerRef.current = setTimeout(()=>{
            safeClosePopup();
            closePopupTimerRef.current = null;
        }, $cec48c407c49ce5f$var$TOGGLE_DELAY_TIME_MS);
    }, [
        clearOpenPopupTimer,
        safeClosePopup
    ]);
    const startOpenPopupTimer = (0, $42omo.useCallback)(()=>{
        clearClosePopupTimer();
        if (!openPopupTimerRef.current) openPopupTimerRef.current = setTimeout(()=>{
            setIsOpen(true);
            openPopupTimerRef.current = null;
        }, $cec48c407c49ce5f$var$TOGGLE_DELAY_TIME_MS);
    }, [
        clearClosePopupTimer
    ]);
    const handleTriggerMouseEnter = (0, $42omo.useCallback)(()=>{
        startOpenPopupTimer();
    }, [
        startOpenPopupTimer
    ]);
    const handleCardMouseEnter = (0, $42omo.useCallback)(()=>{
        clearClosePopupTimer();
    }, [
        clearClosePopupTimer
    ]);
    const handleMouseLeave = (0, $42omo.useCallback)(()=>{
        if (document.activeElement !== triggerElementRef.current) startClosePopupTimer();
    }, [
        startClosePopupTimer
    ]);
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        onSpotlightClose?.();
        setIsOpen(false);
    }, [
        onSpotlightClose
    ]);
    const getTitle = (0, $42omo.useCallback)(()=>{
        return touchpoint === 'page-header' ? intl.formatMessage($cec48c407c49ce5f$var$i18n.titleForPageHeader) : intl.formatMessage($cec48c407c49ce5f$var$i18n.titleForInlineComment);
    }, [
        touchpoint,
        intl
    ]);
    const getDescription = (0, $42omo.useCallback)(()=>{
        return touchpoint === 'page-header' ? intl.formatMessage($cec48c407c49ce5f$var$i18n.descriptionForPageHeader) : intl.formatMessage($cec48c407c49ce5f$var$i18n.descriptionForInlineComment);
    }, [
        touchpoint,
        intl
    ]);
    const targetWithHoverHandlers = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(children, {
        onMouseEnter: handleTriggerMouseEnter,
        onMouseLeave: handleMouseLeave
    });
    (0, $42omo.useEffect)(()=>{
        // clean up timers when the component unmounts
        return ()=>{
            clearClosePopupTimer();
            clearOpenPopupTimer();
        };
    }, [
        clearClosePopupTimer,
        clearOpenPopupTimer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, targetWithHoverHandlers), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        ref: triggerElementRef,
        testId: "loom-button-spotlight-content-container",
        onMouseEnter: handleCardMouseEnter,
        onMouseLeave: handleMouseLeave,
        xcss: $cec48c407c49ce5f$var$spotlightContentContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
        isVisible: isOpen,
        placement: "left-start",
        dismiss: handleDismiss,
        testId: "loom-button-spotlight-content",
        strategy: "absolute",
        shouldDismissOnClickOutside: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
        testId: "loom-button-spotlight-content-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        as: "span",
        size: "xsmall"
    }, getTitle()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), {
        testId: "loom-button-spotlight-dismiss-button"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdtRy.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        alt: "",
        src: isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($kqrkb))) : (0, (/*@__PURE__*/$parcel$interopDefault($5M6IM)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        as: "p"
    }, getDescription()))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, onSpotlightPrimaryActionClick && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), {
        onClick: onSpotlightPrimaryActionClick
    }, intl.formatMessage($cec48c407c49ce5f$var$i18n.primaryAction))))))));
};
module.exports["LoomSpotlightWrapper"] = $cec48c407c49ce5f$export$fe7da627f6fba85a;

});

parcelRegister("5M6IM", function(module, exports) {
module.exports = new URL("LoomCrossSellPopupCardImageNewVisual_Light.55587eef.png", import.meta.url).toString();

});

parcelRegister("kqrkb", function(module, exports) {
module.exports = new URL("LoomCrossSellPopupCardImageNewVisual_Dark.c1c1769c.png", import.meta.url).toString();

});


//# sourceMappingURL=PageHeaderLoomButton.bbe028df.js.map
